import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/shared/api';

/**
 * Die drei aktuellen Systemprofile und – nur wenn das Apartment noch eine ältere Profilversion
 * nutzt – genau diese Version.
 */
export function usePricingStrategyProfiles(
  propertyId: string | undefined,
  configurationLoaded: boolean,
  activeProfileVersionId: string | null | undefined,
) {
  const api = useApi();
  const profiles = useQuery({
    queryKey: ['pricing-strategy-profiles'],
    queryFn: api.pricingStrategyProfiles.list,
    enabled: Boolean(propertyId),
    staleTime: 5 * 60_000,
  });
  const activeProfileIsCurrent = profiles.data?.some(
    (profile) => profile.versionId === activeProfileVersionId,
  );
  const activeProfile = useQuery({
    queryKey: ['pricing-strategy-profile', activeProfileVersionId],
    queryFn: () => api.pricingStrategyProfiles.get(activeProfileVersionId!),
    enabled: Boolean(
      propertyId &&
      configurationLoaded &&
      profiles.isSuccess &&
      activeProfileVersionId &&
      !activeProfileIsCurrent,
    ),
    staleTime: 5 * 60_000,
  });
  return { profiles, activeProfile };
}
